export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6852.fea2f5fd.jpg";